var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.5,
    height: 12.885,
    viewBox: "0 0 42.5 12.885",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3c58bf;}.b{fill:#293688;}.c{fill:#ffbc00;}.d{fill:#f7981d;}.e{fill:#ed7c00;}.f{fill:#051244;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -175.6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M184.8,192.543l2.159-12.143h3.373l-2.091,12.143Z",
    transform: "translate(-169.217 -4.395)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M184.8,192.543l2.766-12.143h2.766l-2.091,12.143Z",
    transform: "translate(-169.217 -4.395)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M258.321,176.14a8.556,8.556,0,0,0-3.1-.54c-3.373,0-5.8,1.687-5.8,4.115,0,1.821,1.687,2.766,3.036,3.373s1.754,1.012,1.754,1.552c0,.81-1.079,1.214-2.024,1.214a7.332,7.332,0,0,1-3.238-.675l-.472-.2L248,187.743a10.938,10.938,0,0,0,3.845.675c3.575,0,5.936-1.687,5.936-4.25,0-1.417-.877-2.5-2.9-3.373-1.214-.607-1.956-.944-1.956-1.552,0-.54.607-1.079,1.956-1.079a6.187,6.187,0,0,1,2.564.472l.337.135.54-2.631Z",
    transform: "translate(-227.087)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M258.321,176.14a8.556,8.556,0,0,0-3.1-.54c-3.373,0-5.194,1.687-5.194,4.115a3.526,3.526,0,0,0,2.429,3.373c1.349.607,1.754,1.012,1.754,1.552,0,.81-1.079,1.214-2.024,1.214a7.332,7.332,0,0,1-3.238-.675l-.472-.2L248,187.743a10.938,10.938,0,0,0,3.845.675c3.575,0,5.936-1.687,5.936-4.25,0-1.417-.877-2.5-2.9-3.373-1.214-.607-1.956-.944-1.956-1.552,0-.54.607-1.079,1.956-1.079a6.187,6.187,0,0,1,2.564.472l.337.135.54-2.631Z",
    transform: "translate(-227.087)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M365.214,180.4c-.81,0-1.417.067-1.754.877l-5.06,11.266h3.643l.675-2.024h4.317l.4,2.024h3.238L367.844,180.4Zm-1.552,8.1c.2-.607,1.349-3.575,1.349-3.575s.27-.742.472-1.214l.2,1.147s.675,3.036.81,3.71h-2.833Z",
    transform: "translate(-328.178 -4.395)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M366.023,180.4c-.81,0-1.417.067-1.754.877L358.4,192.543h3.643l.675-2.024h4.317l.4,2.024h3.238L367.844,180.4Zm-2.361,8.1c.27-.675,1.349-3.575,1.349-3.575s.27-.742.472-1.214l.2,1.147s.675,3.036.81,3.71h-2.833Z",
    transform: "translate(-328.178 -4.395)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M56.26,189.633l-.337-1.754a9.779,9.779,0,0,0-4.722-5.329l3.036,10.794h3.643L63.343,181.2H59.7Z",
    transform: "translate(-46.883 -5.128)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M56.26,189.633l-.337-1.754a9.779,9.779,0,0,0-4.722-5.329l3.036,10.794h3.643L63.343,181.2H60.375Z",
    transform: "translate(-46.883 -5.128)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,180.4l.607.135c4.317,1.012,7.286,3.575,8.433,6.611l-1.214-5.734c-.2-.81-.81-1.012-1.552-1.012Z",
    transform: "translate(0 -4.395)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,180.4H0c4.317,1.012,7.893,3.643,9.04,6.679l-1.147-4.79a1.647,1.647,0,0,0-1.619-1.282Z",
    transform: "translate(0 -4.395)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M0,180.4H0c4.317,1.012,7.893,3.643,9.04,6.679l-.81-2.631a2.379,2.379,0,0,0-1.417-1.956Z",
    transform: "translate(0 -4.395)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.385 177.354)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M60.365,203.146l-2.294-2.294-1.079,2.563-.27-1.687A9.779,9.779,0,0,0,52,196.4l3.036,10.794h3.643Z",
    transform: "translate(-52 -196.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M188.24,292.168l-2.9-2.968-.54,2.968Z",
    transform: "translate(-173.602 -281.375)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M253.869,274.8h0c.27.27.4.472.337.742,0,.81-1.079,1.214-2.024,1.214a7.332,7.332,0,0,1-3.238-.675l-.472-.2L248,278.645a10.938,10.938,0,0,0,3.845.675,6.679,6.679,0,0,0,4.925-1.687Z",
    transform: "translate(-231.472 -268.189)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M364,228.437h3.171l.675-2.024h4.317l.4,2.024h3.238l-1.147-4.925-4.048-3.913.2,1.079s.675,3.036.81,3.71H368.79c.27-.675,1.349-3.575,1.349-3.575s.27-.742.472-1.214",
    transform: "translate(-337.69 -217.644)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.7531ebe4ae7616d8b983a9bd8a66b74e.svg";
export { ForwardRef as ReactComponent };